import { createContext, useContext, useState } from "react";
import { supabase } from "../supabase/client";

export const DataBaseContext = createContext();

export const useDataBase = () => {
  const context = useContext(DataBaseContext);
  if (!context) {
    throw new Error("Error de contexto en useDataBase");
  }
  return context;
};

export const DataBaseContextProvider = ({ children }) => {
  const [cartas, setCartas] = useState([]);
  const [audiencias, setAudiencias] = useState([]);
  const [resoluciones, setResoluciones] = useState([]);

  const getCartas = async () => {
    const { data, error } = await supabase.from("letters").select(`
                *,
                process (
                    num_process,
                    anio_process,
                    class_process(
                        name
                    )
                ),
                secretaries (
                    users (
                        first_name,
                        last_name
                    )
                ),
                users(
                    first_name,
                    last_name
                ),
                persons (
                    name
                )
                `);
    if (error) console.log("error", error);
    setCartas(data);
  };

  const getAudiencias = async () => {
    const { data, error } = await supabase
      .from("audiences")
      .select(
        `
                *,
                process (
                    num_process,
                    anio_process,   
                    class_process(
                        name
                    )
                ),
                secretaries (
                    users (
                        first_name,
                        last_name
                    )
                )
                `
      )
      .order("date", { ascending: false });
    if (error) console.log("error", error);
    setAudiencias(data);
  };

  const getResoluciones = async () => {
    const { data, error } = await supabase.from("resolutions").select(`
                *,
                process (
                    num_process,
                    anio_process,
                    class_process(
                        name
                    )
                ),
                books (
                    name
                ),
                secretaries (
                    users (
                        first_name,
                        last_name
                    )
                )
                `);
    if (error) console.log("error", error);
    setResoluciones(data);
  };

  return (
    <DataBaseContext.Provider
      value={{
        cartas,
        getCartas,
        audiencias,
        getAudiencias,
        resoluciones,
        getResoluciones,
      }}
    >
      {children}
    </DataBaseContext.Provider>
  );
};
